import { createChatBotMessage } from "react-chatbot-kit";
import * as Colors from "../../../../style/base";
import ExcelrateIcon from "../../../../assets/images/logo.svg";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
const botName = "Excelrate Bot";

const normalizeMarkdown = (text) => {
  if (!text) return "";

  return text
    .replace(/\\n/g, "\n")
    .replace(/\\t/g, " ")
    .replace(/\\u2011/g, "-")
    .replace(/\\u2013/g, "-")
    .replace(/\\u2014/g, "-")
    .replace(/\\u2018|\\u2019/g, "'")
    .replace(/\\u201c|\\u201d/g, '"')
    .trim();
};


const config = {
  initialMessages: [createChatBotMessage(`Hi! I'm ${botName}`)],
  botName: botName,
  customStyles: {
    botMessageBox: {
      backgroundColor: Colors.PRIMARY_COLOR,
    },
    chatButton: {
      backgroundColor: Colors.SECONDARY_COLOR,
    },
  },
  customComponents: {
    botAvatar: (props) => (
      <img src={ExcelrateIcon} alt="Bot" style={{ width: 35, height: 35 }} />
    ),
    header: () => (<div className="chatbot-header" style={{backgroundColor:'#f3f3f3' ,width:"100%", padding: "12px 16px", fontFamily:'sans-serif', color: '#4e4e4e' , border:'none'}}>Excelrate AI</div>),
    botChatMessage: (props) => {
      const { message } = props;

      const formatted = normalizeMarkdown(message);

      return (
        <div style={{ padding:'15px', borderRadius:'20px', backgroundColor:'#e7ebe9' }}>
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              strong: ({ children }) => (
                <strong style={{ fontWeight: 600 }}>
                  {children}
                </strong>
              ),

              h1: ({ children }) => (
                <h1 style={{ fontSize: "20px", fontWeight: 600 }}>
                  {children}
                </h1>
              ),

              h2: ({ children }) => (
                <h2 style={{ fontSize: "18px", fontWeight: 600 }}>
                  {children}
                </h2>
              ),

              h3: ({ children }) => (
                <h3 style={{ fontSize: "16px", fontWeight: 600 }}>
                  {children}
                </h3>
              ),

              h4: ({ children }) => (
                <h4 style={{ fontSize: "15px", fontWeight: 600 }}>
                  {children}
                </h4>
              ),

              h5: ({ children }) => (
                <h5 style={{ fontSize: "14px", fontWeight: 600 }}>
                  {children}
                </h5>
              ),

              h6: ({ children }) => (
                <h6 style={{ fontSize: "14px", fontWeight: 600 }}>
                  {children}
                </h6>
              ),
            }}
          >
            {formatted}
          </ReactMarkdown>
        </div>
      );
    },
  },
};

export default config;
